import React from "react";

const BackArrowIcon = () => {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.51155 4.74723L13.873 4.74723C14.0859 4.74723 14.264 4.81907 14.4075 4.96273C14.5512 5.10623 14.623 5.2844 14.623 5.49723C14.623 5.71007 14.5512 5.88823 14.4075 6.03173C14.264 6.1754 14.0859 6.24723 13.873 6.24723L2.51155 6.24723L5.8038 9.53948C5.95246 9.68832 6.02588 9.8624 6.02405 10.0617C6.02205 10.2611 5.94863 10.4383 5.8038 10.5935C5.64863 10.7485 5.47046 10.8286 5.2693 10.8337C5.06796 10.8389 4.88971 10.7639 4.73455 10.6087L0.255796 6.12998C0.162129 6.03632 0.0961304 5.93757 0.0577974 5.83373C0.0192976 5.7299 4.673e-05 5.61773 4.673e-05 5.49723C4.673e-05 5.37673 0.0192976 5.26457 0.0577974 5.16073C0.0961304 5.0569 0.162129 4.95815 0.255796 4.86448L4.73455 0.385735C4.88338 0.237068 5.05996 0.163651 5.2643 0.165484C5.4688 0.167484 5.64863 0.245984 5.8038 0.400984C5.94863 0.55615 6.02363 0.731817 6.0288 0.927984C6.03396 1.12415 5.95896 1.29982 5.8038 1.45498L2.51155 4.74723Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export default BackArrowIcon;
